import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Switch,
    FormControlLabel, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import Cookies from "js-cookie";
import axios from "axios";

const statuses = [
    { label: 'WAITING', value: 'WAITING' },
    { label: 'NOTIFIED', value: 'NOTIFIED' },
    { label: 'INSIDE', value: 'INSIDE' },
    { label: 'COMPLETE', value: 'COMPLETE' },
    { label: 'NOSHOW', value: 'NOSHOW' },
    { label: 'CANCELLED', value: 'CANCELLED' }
];

const defaultGroupValues = {
    name: '',
    setback: 0,
    size: 1,
    status: 'WAITING',
    type: "WALKIN"
};

const GroupForm = ({ open, onClose, groupData, queueId, onSave }) => {
    const [group, setGroup] = useState(null);

    useEffect(() => {
        if(groupData) {
            setGroup({
                ...groupData,
            });
        } else {
            setGroup({});
        }
    }, [groupData]);


    useEffect(() => {
    }, [group]);

    const handleChange = (event) => {
        setGroup({ ...group, [event.target.name]: event.target.value });
    };


    const handleClose = () => {
        setGroup(defaultGroupValues);
        onClose();
    };


    const handleSave = async () => {
        const csrfToken = Cookies.get('XSRF-TOKEN');
        const headers = { 'X-CSRF-TOKEN': csrfToken };

        try {
            if (groupData) {
                // Update existing group
                await axios.put(`/api/groups/staff/${queueId}`, group, { headers });
            } else {
                // Add new group
                await axios.post('/api/groups/staff', group, { headers });
            }
            onSave(); // Refresh the group list
            handleClose();
        } catch (error) {
            console.error('Error saving group', error);
            // Handle errors (e.g., show an error message)
        }
    };

    // Function to fetch group from the API
    const fetchGroup = async () => {
        try {
            const csrfToken = Cookies.get('XSRF-TOKEN');
            const response = await axios.get(`/api/groups/staff/${groupData?.groupId}`, {
                headers: {
                    'X-CSRF-TOKEN': csrfToken
                }
            });
            setGroup(response.data);
        } catch (error) {
            console.error('Error fetching group', error);
            //setLoading(false);
        }
    };

    //initial run
    useEffect(() => {
        if(groupData){
            fetchGroup();
            setGroup({
                ...groupData,
            });
        } else {
            setGroup(defaultGroupValues);
        }
    }, []);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{display: 'flex', justifyContent: 'space-between', marginInline: 3}}>
                {groupData ? `Edit Group - #${groupData?.groupId}` : 'Add Group'}
            </DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    label="Name"
                    type="string"
                    fullWidth
                    name="name"
                    value={group?.name}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    label="Setback"
                    type="number"
                    fullWidth
                    name="setback"
                    value={group?.setback}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    label="Size"
                    type="number"
                    fullWidth
                    name="size"
                    value={group?.size}
                    onChange={handleChange}
                />
                <FormControl fullWidth margin="dense">
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={group?.status}
                        onChange={handleChange}
                        label="Status"
                        name="status"
                    >
                        {statuses.map((status) => (
                            <MenuItem key={status.value} value={status.value}>
                                {status.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions sx={{display: 'flex', justifyContent: 'space-around ', marginBottom: 2}}>
                <Button onClick={handleClose} variant="contained">Cancel</Button>
                <Button onClick={handleSave} variant="contained">Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default GroupForm;
